import { IVipEquity } from '@/api/types/order';
import Switch from '@/components/Form/Switch';
import Image from '@/components/Image';
import { useReporting } from '@/hooks/useReporting';
import { useStore } from '@/providers/app-store-provider';
import { ProviderType } from '@/reporting';

import { formatPriceNumberWithSymbol } from '@/utils/price';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';

interface BuyVipProps {
  // ref: React.RefObject<any>;
  vipEquity: IVipEquity;
  switchBuyVip: (buyVip: boolean) => void;
  initialBuyVip: boolean;
}

export default function BuyVip({ vipEquity, switchBuyVip, initialBuyVip = false }: BuyVipProps) {
  const t = useTranslations('payment.BuyVip');
  const [vipPrice, setVipPrice] = useState<string>('');
  const [vipFreeThresholdPrice, setVipFreeThresholdPrice] = useState<string>('');
  const [buyVip, setBuyVip] = useState<boolean>(initialBuyVip);
  const { trackEvent } = useReporting();

  const currency = useStore((state) => state.currency);

  const getVipPrice = () => {
    const _vipPrice = vipEquity.vip_price_info.find(
      (item) => item.currency === currency.name,
    ).price;
    setVipPrice(_vipPrice);
  };

  const getVipFreeThresholdPrice = () => {
    const _vipFreeThresholdPrice = vipEquity.vip_free_threshold_all.find(
      (item) => item.currency === currency.name,
    ).price;
    setVipFreeThresholdPrice(_vipFreeThresholdPrice);
  };

  const sendClickVipGa = () => {
    trackEvent(
      {
        eventName: 'click_vip',
        properties: {
          event_label: 'Vip',
          event_category: 'CHECKOUT',
        },
      },
      [ProviderType.GA4],
    );
  };

  const changeAction = (event: React.ChangeEvent<HTMLInputElement>) => {
    setBuyVip(event.target.checked);
    switchBuyVip(event.target.checked);
  };

  useEffect(() => {
    getVipPrice();
    getVipFreeThresholdPrice();
  }, [vipEquity]);

  return (
    <div className="flex flex-col gap-4 p-[10px_0px_10px_0px] md:p-0">
      <div className="flex items-center gap-2">
        <Image src="/payment/zing.png" alt="" width={20} height={20} onClick={sendClickVipGa} />
        <div className="font-bb text-[14px] ml-[8px] leading-[17px] flex flex-wrap md:flex-nowrap">
          <span className="whitespace-nowrap">{t('freeBusinessExpress')} </span>
          <span className="font-br text-14 whitespace-nowrap">
            <span>&nbsp;{t('for')} </span>
            <span className="font-br">{formatPriceNumberWithSymbol(vipPrice, currency)}</span>/
            {t('year')}
          </span>
        </div>
        <div className="flex-1 flex justify-end">
          <Switch checked={buyVip} onChange={changeAction} width={42} height={22} />
        </div>
      </div>

      <div className=" text-secondary-text text-12 font-br md:text-12 leading-[18px] w-[80%]">
        {t('vipEnjoyFreeBusinessExpress')}
        <span className="notranslate">
          {formatPriceNumberWithSymbol(vipFreeThresholdPrice, currency)}
        </span>
      </div>
    </div>
  );
}
